export default x => Object.prototype.toString.call(x) === '[object Number]'
